module.exports = __webpack_public_path__ + "img/0030.c9803bf9.png";